import React from "react";
import { message, Form, Collapse, Radio, Checkbox } from "antd";
import styled from "styled-components";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";

export default function VariableProduct({ form, initialValue, type }) {
  const [titleValue, setTitleValue] = React.useState(null);
  const [priceValue, setPriceValue] = React.useState(null);
  const [offValue, setOffValue] = React.useState("");
  const [variant, setVariant] = React.useState(type === 1 ? "کیلوگرم" : "سایز");
  const [list, setList] = React.useState(
    initialValue?.length && typeof initialValue === "object" ? initialValue : []
  );
  console.log("variable, ", initialValue, list, list.length, 1);
  const handleTitleInput = ({ target }) => {
    setTitleValue(target.value);
  };
  const handlePriceInput = ({ target }) => {
    setPriceValue(target.value);
  };
  const handleOffInput = ({ target }) => {
    setOffValue(target.value);
  };
  const handleAdd = () => {
    if (!priceValue) {
      message.error("لطفا مقدار متغیر را تایپ کنید.");
      return false;
    }
    if (!titleValue) {
      message.error("لطفا عنوان متغیر را تایپ کنید.");
      return false;
    }
    setList((e) => [
      ...e,
      {
        title: `${titleValue} ${variant}`,
        price: priceValue,
        off_price: offValue,
      },
    ]);
    setTitleValue(null);
    setPriceValue(null);
    setOffValue(null);
    return false;
  };
  const handleEdit = ({ target }) => {
    let index = Number(target.dataset.index);
    let type = target.dataset.type;
    console.log(index, type, target.innerText);
    if (!target.innerText) {
      target.innerText = list[index][type];
      message.info("بازیابی شد.");
      return false;
    }
    if (target.innerText !== list[index][type]) {
      let value =
        type !== "title" ? !!Number(target.innerText) || "" : target.innerText;
      if (type === "price" && !value) {
        message.error("لطفا یک قیمت معتبر وارد کنید");
        setList((list) => {
          let temp = [...list];
          return temp;
        });
        return;
      }
      setList((list) => {
        let temp = [...list];
        temp[index][type] = value;
        return temp;
      });
      message.success("با موفقیت آپدیت شد.");
    }
    return;
  };
  const handleDelete = (key) => {
    setList((e) => {
      let newList = [...e];
      newList.splice(key, 1);
      console.log(key, newList);
      return newList;
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };
  const handleVariant = (e) => {
    console.log(e.target.value);
    setVariant(e.target.value);
  };

  React.useEffect(() => {
    form.setFieldsValue({ variable: list });
  }, [list]);
  return (
    <Form.Item name="variable">
      <Container key="2">
        <h2 style={{ margin: "20px 0 12px 0" }}>محصول متغیر :</h2>

        {list?.length
          ? list?.map((item, key) => (
              <div className="item" key={key}>
                <span
                  data-index={key}
                  data-type="title"
                  contentEditable="true"
                  className="notranslate"
                  translate="no"
                  onBlur={handleEdit}
                >
                  {item.title}
                </span>
                <span
                  data-index={key}
                  data-type="price"
                  contentEditable="true"
                  className="notranslate"
                  translate="no"
                  onBlur={handleEdit}
                >
                  {item.price}
                </span>
                <span
                  data-index={key}
                  data-type="off_price"
                  contentEditable="true"
                  className="notranslate"
                  translate="no"
                  onBlur={handleEdit}
                >
                  {item.off_price}
                </span>
                <DeleteOutlined
                  className="delete"
                  onClick={() => handleDelete(key)}
                />
              </div>
            ))
          : null}
        <InputContainer>
          <Input
            placeholder={type === 1 ? "وزن" : "سایز"}
            value={titleValue}
            onChange={handleTitleInput}
            onKeyDown={handleKeyDown}
            autoComplete={type === 1 ? "weight" : "size"}
            suffix={
              type === 1 ? (
                <Radio.Group value={variant} onChange={handleVariant}>
                  <Radio.Button value="گرم">g</Radio.Button>
                  <Radio.Button value="کیلوگرم">kg</Radio.Button>
                </Radio.Group>
              ) : null
            }
          />
          <div className="row" style={{ justifyContent: "space-between" }}>
            <Input
              placeholder="قیمت"
              value={priceValue}
              onChange={handlePriceInput}
              onKeyDown={handleKeyDown}
            />
            <Input
              placeholder="قیمت تخفیف"
              value={offValue}
              onChange={handleOffInput}
              onKeyDown={handleKeyDown}
            />
          </div>
          <Button type="button" size="middle" onClick={handleAdd}>
            <PlusOutlined />
            اضافه کردن{" "}
          </Button>
        </InputContainer>
      </Container>
    </Form.Item>
  );
}

const Container = styled.div`
  text-align: start;

  & .item {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > span:first-child {
      border-left: 1px solid #d5d5d5;
    }
    > span {
      width: calc(50% - 18px);
      display: inline-flex;
    }

    & .delete {
      color: red;
      margin-right: auto;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
      width: 36px;
    }
  }
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  & > div {
    width: 100%;
    min-width: 120px;
    height: 50px;
    margin-top: 0;
    input,
    .ant-input-affix-wrapper {
      height: 40px;
      padding: 0 11px 0 0 !important;
    }
  }
  button {
    width: 100%;
    height: 38px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  & .ant-radio-button-wrapper-checked span {
    background-color: ${colors.primary};
  }
`;
